import { render, staticRenderFns } from "./acquista-un-buono.vue?vue&type=template&id=2f8ba3ec"
import script from "./acquista-un-buono.vue?vue&type=script&lang=js"
export * from "./acquista-un-buono.vue?vue&type=script&lang=js"
import style0 from "./acquista-un-buono.vue?vue&type=style&index=0&id=2f8ba3ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports